import './footer.scss'
let Footer=()=> {
  return (
    <div className="footerContainer">
      <div className="footerLogoContainer">
        
      </div>
      <div className="footerTitleContainer">
        <h1 className="footerTitle"></h1>
      </div>
    </div>
  );
}
export default Footer;